import { PlaceholderValue } from "./PlaceholderValue";
import { type TraderListItem } from "./types";
import { getTraderName } from "./utils";

const NameCell = ({ trader }: { trader: TraderListItem }) => (
  <div className="min-w-0 whitespace-normal wrap-break-words font-medium text-foreground">
    {getTraderName(trader) || <PlaceholderValue />}
  </div>
);

export { NameCell };
